module.exports = __webpack_public_path__ + "static/media/logo.4289e6f7.svg";